import { useEffect, useRef, useState } from 'react'

interface UseInlineRenameProps {
    initialName: string
    isRenaming: boolean
    onRename?: (newName: string) => void
    onCancel?: () => void
}

export function useInlineRename({ initialName, isRenaming, onRename, onCancel }: UseInlineRenameProps) {
    const [editName, setEditName] = useState(initialName)
    const inputRef = useRef<HTMLInputElement>(null)

    useEffect(() => {
        if (isRenaming && inputRef.current) {
            inputRef.current.focus()
            inputRef.current.select()
        }
    }, [isRenaming])

    useEffect(() => {
        setEditName(initialName)
    }, [initialName])

    const handleSubmit = () => {
        if (editName.trim() && editName !== initialName) {
            onRename?.(editName.trim())
        } else {
            onCancel?.()
        }
    }

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === 'Enter') {
            e.preventDefault()
            handleSubmit()
        } else if (e.key === 'Escape') {
            e.preventDefault()
            setEditName(initialName)
            onCancel?.()
        }
    }

    return { editName, setEditName, inputRef, handleSubmit, handleKeyDown }
}
